import { render, staticRenderFns } from "./EditCreatedDate.vue?vue&type=template&id=5b5b8728&scoped=true"
import script from "./EditCreatedDate.vue?vue&type=script&lang=js"
export * from "./EditCreatedDate.vue?vue&type=script&lang=js"
import style0 from "./EditCreatedDate.vue?vue&type=style&index=0&id=5b5b8728&prod&lang=scss&scoped=true"


/* normalize component */
import normalizer from "!../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "5b5b8728",
  null
  
)

export default component.exports